import {
    QueryResponse,
    useQueryGetStoredFilterBulkAssignToUser,
} from 'api/queries/getStoredFilterBulkAssignToUser.query';
import { useProjectTreeStore } from 'store/projectContract.store';
import { DndTable } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/DndTable/dndTable';
import {
    columns,
    reorderRows,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/EditBulkActionRules/editBulkActionRules.utils';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';
import { useMutationReorderRankForStoredFilterBulkAssignToUser } from 'api/mutations/reorderRankForStoredFilterBulkAssignToUser.mutation';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

export const EditBulkActionRules = () => {
    const { contract } = useProjectTreeStore();
    const { handleSnackBar } = useCustomSnackBar();

    const { data, refetch } = useQueryGetStoredFilterBulkAssignToUser({ contractId: contract?.id });

    const { mutate } = useMutationReorderRankForStoredFilterBulkAssignToUser();

    const handleRankReorder = (arr: QueryResponse['userAssignRule']) => {
        if (!contract) return null;

        const payload = reorderRows<QueryResponse['userAssignRule'][0]>(arr);

        mutate(
            {
                idList: payload,
                contractId: contract.id,
            },
            {
                onSuccess: () => {
                    handleSnackBar('Successfully Reordered!', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    refetch();
                },
            },
        );
    };

    return (
        <WidgetWithTitle title={'Bulk Assign Users Rules'} tooltip={data?.info}>
            {data && (
                <DndTable<QueryResponse['userAssignRule'][0]>
                    columns={columns}
                    data={data?.userAssignRule}
                    handleRankReorder={handleRankReorder}
                />
            )}
        </WidgetWithTitle>
    );
};
